import ActionColumnController from './action-column.controller';
import { ActionColumnProps } from './action-column.model';

const ActionColumn = (props: ActionColumnProps) => {
  return <ActionColumnController {...props} />;
};

export default ActionColumn;
